export default "__VITE_ASSET__C2Ji01LN__"